import { useTranslation } from 'react-i18next'

import * as Styles from './styles'

const InvalidPasswordError = () => {
  const { t } = useTranslation()

  return (
    <Styles.InvalidPasswordErrorContainer>
      <p>{t('La nueva contraseña debe cumplir con los siguientes requisitos de seguridad:')}</p>
      <ul>
        <li>{t('No puede parecerse a otros datos de la cuenta')}</li>
        <li>{t('No puede ser una contraseña usada habitualmente')}</li>
        <li>{t('Debe tener al menos 8 caractéres')}</li>
        <li>{t('Debe contener al menos 1 letra mayúscula')}</li>
        <li>{t('Debe contener al menos 1 letra minúscula')}</li>
        <li>{t('Debe contener al menos 1 número')}</li>
      </ul>
    </Styles.InvalidPasswordErrorContainer>
  )
}

export default InvalidPasswordError
